module.exports = __webpack_public_path__ + "static/img/idcard.1cc970ef.svg";